import { lazy } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import AuthRoutes from "./AuthRoutes";
import Login from "../components/pages/auth/Login";
import PrivateRoutes from "./PrivateRoutes";
// import QuestionnairePage from '../components/pages/views/questionnaire/QuestionnairePage';
import Questionnaire from "../components/pages/questionnaire/Questionnaire";
import QuestionOptions from "../components/pages/question-options/QuestionOptions";
import CriteriaGroups from "../components/pages/criteria-groups/CriteriaGroups";
import Repeats from "../components/pages/repeats/Repeats";

// import { oldStages } from '../constants/auth_stages';

// import AuthRoutes from './AuthRoutes';
// import PrivateRoutes from './PrivateRoutes';

// const CommingSoonPage = lazy(() => import('../components/pages/CommingSoon'));
const ErrorPage = lazy(() => import("../components/pages/Error"));
// const QuestionnairePage = lazy(() => import('../components/pages/Questionnaire'));

// const Authentication = lazy(() => import('../components/older/Containers/Authentication'));
// const Activation = lazy(() => import('../components/older/Containers/Activation'));
// const Home = lazy(() => import('../components/older/Containers/Home'));
// const Notifications = lazy(() => import('../components/older/Containers/Notifications'));
// const BookConsult = lazy(() => import('../components/older/Containers/BookConsult'));
// const PaymentsConfirmed = lazy(() => import('../components/older/Containers/Payments/payments_confirmed'));
// const QuestionnaireDashboard = lazy(() => import('../components/older/Containers/QuestionnaireDashboard'));
// const QuestionDisclaimerView = lazy(() => import('../components/older/Containers/QuestionDisclaimer/QuestionDisclaimerView'));

const NavigationRoutes = () => {
  return (
    <Routes>
      {/* <Route element={<AuthRoutes />}>
                <Route path="/auth" element={<Authentication initialStage={window.location.search.includes("?pc=") ? oldStages.SIGNUP_INFO : oldStages.SIGNIN_INFO} />} />
                <Route path="/activate" element={<Activation />} />
                <Route path="/reset-password" element={<Authentication initialStage={oldStages.RESET_PASSWORD} />} />
                <Route path="/password-changed" element={<Authentication initialStage={oldStages.SIGNIN_INFO} />} />
            </Route>

            <Route element={<PrivateRoutes />}>
                <Route path="/" element={<Home />} />
                <Route path="/notifications" element={<Notifications />} />
                <Route path="/book-consult" element={<BookConsult />} />
                <Route path="/payments-confirmed" element={<PaymentsConfirmed />} />
                <Route path="/questionnaire_dashboard" element={<QuestionnaireDashboard />} />
                <Route path='/question_disclaimer' element={<QuestionDisclaimerView />} />
                <Route path='/questionnaire' element={<QuestionnairePage />} />
            </Route> */}
      <Route element={<AuthRoutes />}>
        <Route element={<Login />} path="/login" />
      </Route>

      <Route element={<PrivateRoutes />}>
        <Route path="/" element={<Navigate to={'/questionnaire/:questcode/questions'} />} />
        <Route path="/questionnaire" element={<Navigate to={'/questionnaire/:questcode/questions'} />} />
        <Route path="/questionnaire/:questcode/questions" element={<Questionnaire />} />
        <Route path="/questionnaire/:questcode/criterias" element={<CriteriaGroups />} />
        <Route path="/questionnaire/:questcode/options" element={<QuestionOptions />} />
        <Route path="/questionnaire/:questcode/repeats" element={<Repeats />} />
      </Route>

      <Route path="*" element={<ErrorPage />} />
    </Routes>
  );
};

export default NavigationRoutes;
